import { render, staticRenderFns } from "./testApp.vue?vue&type=template&id=b207ebfe&"
import script from "./testApp.vue?vue&type=script&lang=js&"
export * from "./testApp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports